module.exports = __webpack_public_path__ + "0b7120acdfed3535bddaf5f857d18e9d.png";